module.exports = __webpack_public_path__ + "img/banner-1_AR.96f337a9.png";